import type { AppMode } from 'src/App/context/PricingContextProvider';

import { PricingModel } from '../Product';

export const getPricingType = (pricingModel: PricingModel) =>
  pricingModel === PricingModel.HORIZON ? 'variable' : 'fixed';

export const getCurrentPage = (appMode: AppMode) => {
  switch (appMode) {
    case 'PREVIEW':
      return 'ad price lookup preview';
    default:
      return 'ad price lookup full';
  }
};

export const getEventName = (appMode: AppMode) => {
  switch (appMode) {
    case 'PREVIEW':
      return 'ad_price_lookup_preview_displayed';
    default:
      return 'ad_price_lookup_full_displayed';
  }
};
